import { Destacado } from './Destacado';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import { useLayoutEffect, useState } from 'react';
import { GenericComponentProps, ModuleContainerGeneric } from '@bpba/modules-components';
import { ProductoData } from '../../model/ProductoData';
import { CanjeDialog } from '../canje/CanjeDialog';
import { useCanjeActivation } from '../canje/useCanjeActivation';
import { Titulo } from '../shared/Titulo';
import { StyledModuleContainerGeneric } from '../shared/StyledModuleContainerGeneric';

export const DestacadosComponent = (props: GenericComponentProps<ProductoData>) => {
  const { showCanje, onClickCanje, closeCanje, selectedProduct, openCanje } = useCanjeActivation();
  const [slides, setSlides] = useState<number>(3);

  const getSlidesPerView = () => {
    const width = window.innerWidth;

    if (width <= 667) {
      return setSlides(1);
    } else if (width > 667 && width <= 1180) {
      return setSlides(2);
    } else if (width > 1180) {
      return setSlides(2);
    }
  };

  useLayoutEffect(() => {
    const handleResize = () => {
      getSlidesPerView();
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return (
    <>
      <StyledModuleContainerGeneric
        paddingBottom={['32px !important']}
        paddingTop={['32px !important', '16px !important', null, null, '40px !important']}
      >
        <Titulo>{props.moduloTitulo}</Titulo>
      </StyledModuleContainerGeneric>
      <ModuleContainerGeneric
        paddingTop={'0px !important'}
        paddingBottom={['40px!important']}
        paddingX={['8px', '51px', null, null, '99px']}
        maxWidth={'1168px !important'}
      >
        <Swiper
          pagination={true}
          spaceBetween={0}
          modules={[Autoplay]}
          slidesPerView={slides}
          autoplay={{
            delay: 2500,
            disableOnInteraction: true,
          }}
          style={{ width: '100%' }}
        >
          {props.data.map((destacado, index) => {
            return (
              <SwiperSlide key={destacado.codigo}>
                <Destacado data={destacado} isLast={index === props.data.length - 1} onClickCanje={onClickCanje} />
              </SwiperSlide>
            );
          })}
        </Swiper>

        <CanjeDialog show={showCanje} product={selectedProduct} close={closeCanje} reopen={openCanje} />
      </ModuleContainerGeneric>
    </>
  );
};
